import React, { useMemo, useState } from "react";
import { DateRangePicker, CustomProvider } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import { Box } from "@mui/material";
import { add } from "date-fns";

// ---- date helpers
export const startOfDay = d => (d = new Date(d), d.setHours(0,0,0,0), d);
export const endOfDay   = d => (d = new Date(d), d.setHours(23,59,59,999), d);
export const addDays    = (d,n) => (d = new Date(d), d.setDate(d.getDate()+n), d);
export const startOfMonth = d => startOfDay(new Date(d.getFullYear(), d.getMonth(), 1));
export const endOfMonth   = d => endOfDay(new Date(d.getFullYear(), d.getMonth()+1, 0));
export const startOfYear  = d => startOfDay(new Date(d.getFullYear(), 0, 1));
export const startOfQuarter = d => startOfDay(new Date(d.getFullYear(), Math.floor(d.getMonth()/3)*3, 1));

export default function HistoryOnlyPicker({range, setRange, maxRangeDays}) {
  const today = new Date();
  const todayStart = startOfDay(today);
  const todayEnd = endOfDay(today);

  // block future dates
  const disabledDate = d => d.getTime() > todayEnd.getTime();

  const ranges = useMemo(() => {
    const mkLastNDays = n => () => [startOfDay(addDays(todayStart, -n)), todayEnd];
    return [
      { label: "Last 7 days", value: mkLastNDays(7) },
      { label: "Last 14 days", value: mkLastNDays(14) },
      { label: "Last 30 days", value: mkLastNDays(30) },
      { label: "Last 60 days", value: mkLastNDays(60) },
      { label: "Last 90 days", value: mkLastNDays(90) },
      { label: "Month to date", value: () => [startOfMonth(todayStart), todayEnd] },
      { label: "Quarter to date", value: () => [startOfQuarter(todayStart), todayEnd] },
      { label: "Year to date", value: () => [startOfYear(todayStart), todayEnd] },
    ];
  }, [todayStart, todayEnd]);

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <DateRangePicker
        value={range}
        onChange={(next) => {
          if (!next) return setRange(next);
          let [s, e] = next;

          // clamp future end date
          if (e.getTime() > todayEnd.getTime()) e = todayEnd;

          // enforce max 90-day range
          const diffDays = Math.round((e - s) / (1000 * 60 * 60 * 24));
          if (diffDays > maxRangeDays) {
            // clamp start date so that range is maxRangeDays
            s = addDays(e, -maxRangeDays);
          }

          setRange([s, addDays(e, 1)]); // make end exclusive
        }}
        ranges={ranges}
        disabledDate={disabledDate}
        format="yyyy-MM-dd"
        cleanable={false}
        character=" → "
      />
    </Box>
  );
}